import { AVAILABILITY_SLOTS, LOADING } from "../actionType/availabilityType";
import { availabilitySlots, availabilityTimezone } from "../constant/Constant";
import {
  getAuthMethod,
  postAuthMethod,
  putAuthMethod,
} from "../services/HttpServices";

export const createAvailabilitySlots = (payload) => (dispatch) => {
  dispatch({
    type: LOADING,
    payload: true,
  });
  return postAuthMethod(availabilitySlots, payload)
    .then((res) => {
      dispatch({
        type: LOADING,
        payload: false,
      });
      return res;
    })
    .catch((err) => {
      dispatch({
        type: LOADING,
        payload: false,
      });
      return err;
    });
};

export const updateAvailabilitySlots = (payload) => (dispatch) => {
  dispatch({
    type: LOADING,
    payload: true,
  });

  return putAuthMethod(availabilitySlots, null, payload)
    .then((res) => {
      dispatch({
        type: LOADING,
        payload: false,
      });
      return res;
    })
    .catch((err) => {
      dispatch({
        type: LOADING,
        payload: false,
      });
      return err;
    });
};

export const getAvailabilitySlots = (payload) => (dispatch) => {
  dispatch({
    type: LOADING,
    payload: true,
  });

  return getAuthMethod(availabilitySlots)
    .then((res) => {
      dispatch({
        type: AVAILABILITY_SLOTS,
        payload: res?.data,
      });
      dispatch({
        type: LOADING,
        payload: false,
      });
    })
    .catch((err) => {
      dispatch({
        type: LOADING,
        payload: false,
      });
      if (!err?.response?.data) return;
      return err;
    });
};

export const updateAvailabilityTimezone = (payload) => (dispatch) => {
  dispatch({
    type: LOADING,
    payload: true,
  });

  return putAuthMethod(availabilityTimezone, null, payload)
    .then((res) => {
      dispatch({
        type: LOADING,
        payload: false,
      });
      return res;
    })
    .catch((err) => {
      dispatch({
        type: LOADING,
        payload: false,
      });
      return err;
    });
};

export const getAvailabilityTimezone = (payload) => (dispatch) => {
  dispatch({
    type: LOADING,
    payload: true,
  });

  return getAuthMethod(availabilityTimezone)
    .then((res) => {
      dispatch({
        type: LOADING,
        payload: false,
      });
      return res;
    })
    .catch((err) => {
      dispatch({
        type: LOADING,
        payload: false,
      });
      if (!err?.response?.data) return;
      return err;
    });
};
